<template>
  <v-card :loading="loading" :disabled="loading">
    <CardTitle :title="title ? 'Samples: '+ title : 'Samples'">
      <template v-slot:actions>
        <i>This table will ONLY load samples related to the customer you searched and selected.</i>
        <slot name="title_actions"></slot>
      </template>
    </CardTitle>
    <v-card-text :class="dialog ? '' : 'overflow-y-auto'" :style="dialog ? '' : 'height:80vh'">
      <SampleTrackingTable ref="tracking_table" :add_where="[{key: 'customer_id', value: customer_id}]" :disabled_headers="['Customer']"></SampleTrackingTable>
    </v-card-text>
    <slot name="actions"></slot>
  </v-card>
</template>

<script>
export default {
  name: "Samples",
  components: {
    SampleTrackingTable: () => import("@/components/general/samples/SampleTrackingTable")
  },
  data: () => ({
  }),
  props:{
    customer_id: {
      required: true,
    },
    title:{
      required: false,
    },
    dialog: {
      default: false,
      type: Boolean
    }
  },
  watch:{
    customer_id(){
      if(!this.loading){
        this.loadData();
      }
    }
  },
  mounted(){
    if(!this.loading){
      this.loadData();
    }
  },
  methods:{
    async loadData(){
      this.extraData();
      // this.loading = true;
      //   await this.$refs.tracking_table.loadSamples();
      //   this.loading = false;
      // }
    },
    extraData(){
      // this.$store.$db().model('nameTypes').api().fetch();
    }
  }
}
</script>

<style scoped>

</style>
